<section class="order-summary">
  <h2>{{ 'APP.CART_ORDER_SUMMARY' | translate }}</h2>
  <div class="summary-row">
    <span>{{ 'APP.CART_SUBTOTAL' | translate }}</span>
    <span>{{ subtotal | currency:'USD':'symbol':'1.0-0' }}</span>
  </div>
  <div class="summary-row">
    <span>{{ 'APP.CART_DISCOUNT' | translate }}</span>
    <span class="discount">-{{ discount | currency:'USD':'symbol':'1.0-0' }}</span>
  </div>
</section>
